import { render, staticRenderFns } from "./SubcategoriesList.vue?vue&type=template&id=53b3d15d"
import script from "./SubcategoriesList.vue?vue&type=script&lang=js"
export * from "./SubcategoriesList.vue?vue&type=script&lang=js"
import style0 from "./SubcategoriesList.vue?vue&type=style&index=0&id=53b3d15d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports